/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/hubspot" */ '@atlassian/logo-third-party/hubspot'
		).then((m) => m.HubSpotIcon),
	{ moduleId: '@atlassian/logo-third-party/hubspot' },
);

const LazyHubSpotFilterIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-hubspot" */ './utils').then((m) => m.HubSpotFilterIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/hubspot/icon' },
);

const LazyHubSpotIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-hubspot-search-result" */ './utils').then(
			(m) => m.HubSpotIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/hubspot/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const HubSpotFilterIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyHubSpotFilterIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const HubSpotIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyHubSpotIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
